import React from "react";
import { useNavigate } from "react-router-dom";

import { SelectLanguage } from "../SelectLanguage";
import { useAuth } from "../../hooks/useAuth";
import { Avatar, Link, Paper, Stack, Typography } from "@mui/material";

const NaveBar = () => {
  const { user } = useAuth();
  const navigate = useNavigate();

  return (
    <Stack
      direction="row"
      justifyContent="flex-end"
      alignItems="center"
      spacing={2}
      sx={{
        width: 1,
        height: 80,
        padding: "0 1rem",
        backgroundImage: (theme) =>
          `linear-gradient(269deg, ${theme.palette.primary.light} 1%, ${theme.palette.primary.dark} 80%)`,
      }}
    >
      <Stack
        component={Link}
        underline="none"
        color="white"
        href="/profile"
        direction="row"
        spacing={2}
        alignItems="center"
        onClick={() => {
          navigate("/profiles");
        }}
      >
        <Avatar sx={{ color: "primary.main", bgcolor: "white", fontSize: 20 }}>
          {user.sigla}
        </Avatar>
        <Typography sx={{ fontSize: 12 }}>{user.name}</Typography>
      </Stack>
      <Paper>
        <SelectLanguage />
      </Paper>
      {/* <BellNotifications data-notifications="3">
          <FiBell />
        </BellNotifications> */}
    </Stack>
  );
};

export { NaveBar };
